import React, { useEffect, useState } from "react";
import AdvancePaymentListing from "./AdvancePaymentListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setIsOpenAddDialog,
  setIsOpenEditDialog,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/AdvancePaymentSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import AddAdvancePaymentWrapper from "../Add/AddAdvancePaymentWrapper";
import {
  useChangeStatusAdvancePaymentByIdMutation,
  useGetAllAdvancePaymentDataQuery,
} from "src/services/AdvancePaymentService";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
import CancelAdvancePaymentWrapper from "../Cancel/CancelAdvancePaymentWrapper";
import { usePermission } from "src/hooks/usePermission";
import { Tooltip } from "@mui/material";

type Props = {};

const AdvancePaymentListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isOpenAddDialog,
    isOpenEditDialog,
    isTableLoading,
  } = useSelector((state: RootState) => state.advancePayment);
  const [selectedAdvancePaymentId, setSelectedAdvancePaymentId] =
    useState<string>();

  // const [deleteAdvancePayment] = useDeleteAdvancePaymentByIdMutation();
  const [changeStatusAdvancePayment] =
    useChangeStatusAdvancePaymentByIdMutation();
  const { data, isLoading, isFetching } = useGetAllAdvancePaymentDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name", "amount", "mobile", "paymentMode"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

  // const handleDeleteAdvancePayment = (row: string) => {
  //   showConfirmationDialog({
  //     title: "Hands Up",
  //     text: "Are you sure want to delete this Advance Payment ?",
  //     icon: "question",
  //     showCancelButton: true,
  //     next: (result) => {
  //       if (result?.isConfirmed) {
  //         deleteAdvancePayment(row).then((res: any) => {
  //           if (res.error) {
  //             showToast("error", res?.error?.data?.message);
  //           } else {
  //             showToast("success", res?.data?.message);
  //           }
  //         });
  //       }
  //     },
  //   });
  // };

  const handleChangeStatusAdvancePayment = (row: any) => {
    const actionLabel = row?.isActive ? "deactive" : "active";
    showConfirmationDialog({
      title: "Hands Up",
      text: `Are you sure want to ${actionLabel} this Advance Payment ?`,
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result?.isConfirmed) {
          changeStatusAdvancePayment({ id: row?._id }).then((res: any) => {
            if (res.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              showToast("success", res?.data?.message);
            }
          });
        }
      },
    });
  };

  const moduleName = "ADVANCE_PAYMENT";

  const canEdit = usePermission(moduleName, "UPDATE");
  const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

  const columns: columnTypes[] = [
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <span>{row?.name || "-"} </span>,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <span>&#8377;{row?.amount || "-"} </span>,
    },
    {
      field: "remark",
      headerName: "Remark",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <span>{row?.remark || "-"} </span>,
    },
    { field: "mobile", headerName: "Mobile Number", flex: "flex-[1_1_0%]" },
    // {
    //   field: "paymentMode",
    //   headerName: "Payment Mode",
    //   flex: "flex-[1.8_1.8_0%]",
    //   renderCell: (row: any) => (
    //    <div className="flex flex-col gap-2">
    //     { row?.paymentMode?.map((el:any)=>{
    //       return(
    //         <div className="flex justify-between gap-4 items-center border-b border-slate-600 last:border-none">
    //           <span className="text-[12px] font-semibold">&#8377;{el?.amount} </span>
    //           <span className="text-[12px] font-semibold">{el?.paymentModeName} </span>
    //         </div>
    //       )
    //     })
    //     || "-"}
    //    </div>
    //   ),
    // },
    {
      field: "adjustOrAdvance",
      headerName: "Adjust/Advance",
      flex: "flex-[1_1_0%]",
       renderCell: (row: any) => (
        <Tooltip title={row?.adjustOrAdvance || "-"}>
          <div className="text-[13px]">
            {row?.adjustOrAdvance
              ? row.adjustOrAdvance.charAt(0).toUpperCase() +
                row.adjustOrAdvance.slice(1).toLowerCase()
              : "-"}
          </div>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              dispatch(setIsOpenEditDialog(true));
              setSelectedAdvancePaymentId(row?._id);
            },
          });
        }

        if (canActive) {
          options.push({
            label: row?.isActive ? "Deactive" : "Active",
            onClick: () => {
              handleChangeStatusAdvancePayment(row);
            },
          });
        }

        return <ATMMenu options={options} /> ;
      },
    },
  ];

  return (
    <>
      {" "}
      <div>
        <AdvancePaymentListing
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) =>
              dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddAdvancePaymentWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      ) : null}
      {isOpenEditDialog ? (
        <CancelAdvancePaymentWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedAdvancePaymentId={selectedAdvancePaymentId || ""}
        />
      ) : null}
    </>
  );
};

export default AdvancePaymentListingWrapper;
